/* eslint-disable multiline-comment-style */
/* eslint-disable camelcase */
// import packages
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Button } from 'react-bootstrap';
// import UserClearance from './UserClearance';
// import StatusClearanceListTable from './components/ViewTable';

// import components
import Filter from './components/Filter';
import ModalAddRecord from './AddRecord';
import AllergiesActionTable from './components/Table';
import { selectPatientData } from 'reducers/patientReducer';
import ModalViewRecord from './view';

// import assets below
import './style.scss';

// main component
const Allergies = () => {
  // eslint-disable-next-line no-unused-vars
  const [showModal, setShowModal] = useState({
    addModal: false,
    profileId: null,
    profileData: null,
    isViewStatus: false,
    isProfileShow: false,
    viewRecordModal: false,
  });

  const data = useSelector(selectPatientData);

  const [filter, setFilter] = useState({
    date: '',
    patient_name: '',
    physician_name: '',
  });

  const [filteredData, setFilteredData] = useState([]);

  return (
    <>
      <div className='allergies mt-4'>
        {!showModal.isProfileShow ? (
          <>
            <Filter
              data={data}
              filter={filter}
              setFilter={setFilter}
              setFilteredData={setFilteredData}
            />
            <div className='allergies-list'>
              <div className='header-cont d-flex justify-content-between align-items-center'>
                <h5 className='fw-bold mb-3'>List of Result</h5>
                <Button
                  onClick={() => {
                    setShowModal((prevState) => {
                      return {
                        ...prevState,
                        addModal: true,
                      };
                    });
                  }}
                >
                  ADD RECORD
                </Button>
              </div>
              {!showModal.isViewStatus ? (
                <AllergiesActionTable
                  filter={filter}
                  data={data}
                  setShowModal={setShowModal}
                  filteredData={filteredData}
                />
              ) : (
                // <StatusClearanceListTable setShowModal={setShowModal} />
                <>View Action Here</>
              )}
            </div>
          </>
        ) : (
          <>Test Here</>
          // <UserClearance showModal={showModal} setShowModal={setShowModal} />
        )}
      </div>
      <ModalViewRecord showModal={showModal} setShowModal={setShowModal} />
      <ModalAddRecord showModal={showModal} setShowModal={setShowModal} />
    </>
  );
};

export default Allergies;
